const apiMethods = {
    methods:{
        getimgurl(){
            let _this=this
            this.axios.get('url/user/imgHttpUrl.json')
            .then(function (res) {
                return res
            })
          },
    }
}
export default apiMethods


// WEBPACK FOOTER //
// ./src/config/common.js